import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api, fileUrl, FALLBACK_COVER } from "@/lib/api";
import { PlayButton } from "@/components/site/ReleaseCard";

export const TrendingTracks = ({ releases }) => {
  const [top, setTop] = useState([]);
  useEffect(() => { api.get("/trending").then((r) => setTop(r.data)).catch(() => {}); }, []);
  const items = top.map((t) => {
    const release = releases.find((r) => r.id === t.release_id);
    const idx = release ? (release.tracks || []).findIndex((x) => x.id === t.track_id) : -1;
    return idx >= 0 ? { ...t, release, idx, track: release.tracks[idx] } : null;
  }).filter(Boolean);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16" data-testid="home-trending">
      <p className="font-mono-tga text-xs uppercase tracking-[0.3em] text-hot inline-flex items-center gap-2"><Flame className="h-4 w-4" /> In tendenza</p>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight mt-3 mb-10">I più ascoltati della settimana</h2>
      <ol className="space-y-3">
        {items.map((t, i) => (
          <li key={t.track_id} className="group flex items-center gap-4 sm:gap-6 rounded-2xl border border-white/10 bg-white/[0.03] p-3 sm:p-4 hover:border-emerald-400/50 hover:bg-white/[0.06] transition-colors rise" style={{ animationDelay: `${i * 80}ms` }} data-testid={`trending-track-${i}`}>
            <span className={`font-display font-black text-3xl sm:text-5xl w-10 sm:w-16 text-center ${i === 0 ? "text-emerald-300" : "text-zinc-600"}`}>{i + 1}</span>
            <Link to={`/uscite/${t.release.id}`} className="shrink-0"><img src={fileUrl(t.release.cover_url) || FALLBACK_COVER} alt={t.release.title} className="h-14 w-14 sm:h-16 sm:w-16 rounded-xl object-cover group-hover:scale-105 transition-transform duration-500" /></Link>
            <div className="flex-1 min-w-0">
              <Link to={`/uscite/${t.release.id}`} className="font-semibold text-base sm:text-lg truncate block hover:text-emerald-300" data-testid={`trending-track-title-${i}`}>{t.track.title}</Link>
              <p className="text-sm text-zinc-400 truncate">{t.release.artist_name}{(t.track.genre || t.release.genre) ? ` · ${t.track.genre || t.release.genre}` : ""}</p>
            </div>
            <span className="hidden sm:inline font-mono-tga text-xs text-zinc-400 whitespace-nowrap">{t.plays_7d} ascolti</span>
            <PlayButton release={t.release} trackIdx={t.idx} testid={`trending-play-${i}`} />
          </li>
        ))}
      </ol>
    </section>
  );
};
